// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeMicroLab = {
  microLabPlatformDataContractInvalid:
    "Micro Lab プラットフォームデータ契約が無効です ({field_name}: {reason})",
} as const;
